import View from './List';
import enhancer from './List.enhancer';

export default enhancer(View);
